/**
 * Utility functions for formatting user-related messages
 */

/**
 * Formats a list of tenant app names into a human-readable string
 * @param {Array<string>} otherApps - Array of tenant app names
 * @returns {string} Formatted string of app names
 *
 * Examples:
 *   [] or null => 'another app'
 *   ['app1'] => 'app1'
 *   ['app1', 'app2'] => 'app1 and app2'
 *   ['app1', 'app2', 'app3'] => 'app1, app2, and app3'
 */
export const formatOtherAppsMessage = (otherApps = []) => {
  if (!otherApps || otherApps.length === 0) {
    return 'another app'
  }

  if (otherApps.length === 1) {
    return otherApps[0]
  }

  if (otherApps.length === 2) {
    return `${otherApps[0]} and ${otherApps[1]}`
  }

  const lastApp = otherApps[otherApps.length - 1]
  const otherAppsList = otherApps.slice(0, -1).join(', ')
  return `${otherAppsList}, and ${lastApp}`
}
